<h2 mat-dialog-title>Filial: {{ data.branchTitle }}</h2>

<mat-dialog-content class="branch-dialog-content">
  <div class="section">
    <h3>Variações disponíveis</h3>
    <div *ngIf="!data?.variations?.length" class="empty">Nenhuma variação selecionada no passo anterior.</div>
    <div class="cards-grid" *ngIf="data?.variations?.length">
      <mat-card
        class="select-card"
        *ngFor="let variation of data.variations"
        [class.selected]="selectedVariationIds.has(variationId(variation))"
        (click)="toggleVariation(variation, !selectedVariationIds.has(variationId(variation)))">
        <div class="card-title">{{ variation.nome || variation.codigo || 'Variação' }}</div>
        <div class="info-row"><span class="info-label">Código:</span><span class="info-value">{{ variation.codigo || '--' }}</span></div>
        <div class="info-row"><span class="info-label">Tipo:</span><span class="info-value">VARIAÇÃO</span></div>
        <div class="info-row"><span class="info-label">Produto/Solução:</span><span class="info-value">{{ variation.solucao || data.solutionName || 'N/A' }}</span></div>
        <div class="info-row"><span class="info-label">Módulo:</span><span class="info-value">{{ (variation.modules && variation.modules.length > 0) ? variation.modules[0].name : 'N/A' }}</span></div>
        <div class="info-row"><span class="info-label">Valor de Acesso:</span><span class="info-value">{{ (variation.valorMensalidade || 0) | currency:'BRL' }}</span></div>
        <div class="info-row"><span class="info-label">Custo:</span><span class="info-value">{{ 0 | currency:'BRL' }}</span></div>
        <div class="info-row"><span class="info-label">Status:</span><span class="info-value">{{ variation.status || 'ATIVO' }}</span></div>
      </mat-card>
    </div>
  </div>

  <div class="section">
    <h3>Módulos extras disponíveis</h3>
    <div *ngIf="!data?.modules?.length" class="empty">Nenhum módulo extra selecionado no passo anterior.</div>
    <div class="cards-grid" *ngIf="data?.modules?.length">
      <mat-card
        class="select-card extra"
        *ngFor="let module of data.modules"
        [class.selected]="selectedModuleIds.has(module.id)"
        (click)="toggleModule(module, !selectedModuleIds.has(module.id))">
        <div class="card-title">{{ module.name }}</div>
        <div class="info-row"><span class="info-label">Código:</span><span class="info-value">{{ module.id || '--' }}</span></div>
        <div class="info-row"><span class="info-label">Tipo:</span><span class="info-value">MÓDULO EXTRA</span></div>
        <div class="info-row"><span class="info-label">Produto/Solução:</span><span class="info-value">{{ data.solutionName || 'N/A' }}</span></div>
        <div class="info-row"><span class="info-label">Módulo:</span><span class="info-value">{{ module.name || 'N/A' }}</span></div>
        <div class="info-row"><span class="info-label">Valor de Acesso:</span><span class="info-value">{{ (module.accessValue || 0) | currency:'BRL' }}</span></div>
        <div class="info-row"><span class="info-label">Custo:</span><span class="info-value">{{ (module.cost || 0) | currency:'BRL' }}</span></div>
        <div class="info-row"><span class="info-label">Status:</span><span class="info-value">ATIVO</span></div>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef.close()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()">Salvar</button>
</mat-dialog-actions>
